module.exports = __webpack_public_path__ + "img/winfit-spinner.e9bf3371.png";